module.exports = __webpack_public_path__ + "img/love.61399af1.png";